export default {
    SM: 'player-sm',
    MED: 'player-med',
    LG: 'player-lg',
    XLG: 'player-xlg',
};
